import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AbstractCrudService} from '../shared/abstract-crud.service';
import {AutomationMapping} from './automation-mapping.model';

/**
 * Service for interacting with Mipro VIVO API.
 */
@Injectable()
export class AutomationService extends AbstractCrudService<AutomationMapping> {
  /**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'automationmappings';

  private mappings: Promise<AutomationMapping[]>;

  /**
   * Default constructor
   * @param {HttpClient} http - refined http service, automatically adds authentication token
   */
  constructor(protected http: HttpClient) {
    super(http);

    this.mappings = new Promise((resolve, reject) => {
      this.list().then(result => {
        resolve(result.data);
      }, reject);
    });
  }

  public async getAutomationIdForRegoId(regoId: string): Promise<string> {
    try {
      return (await this.mappings).find(o => {
        return o.regoId + '' === regoId + '';
      }).automationId;
    } catch (e) {
      return null;
    }
  }

  public async getRegoIdForAutomationId(autoId: string): Promise<string> {
    try {
      return (await this.mappings).find(o => {
        return o.automationId + '' === autoId + '';
      }).regoId;
    } catch (e) {
      return null;
    }
  }

}
